export default __webpack_public_path__ + "static/media/nft16.85e5f7b9.png";